import { Helmet } from 'react-helmet-async';
import GeorgianPhysicalPaymentView from 'src/sections/payments/view/georgian-physical-payment-view';

export default function GeorgianPhysicalPaymentPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Georgian Physical Order Payments</title>
      </Helmet>

      <GeorgianPhysicalPaymentView />
    </>
  );
}
